export class CarveOutAddCommand{
    contractId:string;
    code:string;
    description:string;
    rate:number;
    applyMultiProcedureDisc:boolean;
    isCaseRate:boolean;

    constructor(contractId:string,code:string,description:string,rate:number,applyMultiProcedureDisc:boolean, isCaseRate:boolean){
        this.contractId = contractId;
        this.code = code;
        this.description = description;
        this.rate = rate;
        this.applyMultiProcedureDisc = applyMultiProcedureDisc;
        this.isCaseRate = isCaseRate;
    }

}